import script from "./StructuredDataBreadcrumbList.vue?vue&type=script&lang=js"
export * from "./StructuredDataBreadcrumbList.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__